import { render, staticRenderFns } from "./a-svg-waveform.vue?vue&type=template&id=005f2b9a&scoped=true"
import script from "./a-svg-waveform.vue?vue&type=script&lang=js"
export * from "./a-svg-waveform.vue?vue&type=script&lang=js"
import style0 from "./a-svg-waveform.vue?vue&type=style&index=0&id=005f2b9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "005f2b9a",
  null
  
)

export default component.exports